/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/user
 */
import { default as DefaultIcon } from '~icons/lucide/user';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const UserIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
